import { actionTypes } from "../contants/actionTypes";

const initialState = {
    updatingFlows: false,
    deletingFlows: false,
    flowInEdition: {},
    listSchemes: [],
    listFunctionsSchema: [],
    listTypesComponent: [],
    isChangesPendingFlow: false,
    isErrorFetch: false,
    messageErrorFetch: '',
    loadingAllConfig: false,
}

export const flowReducer = (state = initialState, action) => {

    switch (action.type) {
        //IsChangingPending
        case actionTypes.floErrorManageFlows:
            return {
                ...state,
                isErrorFetch: action.payload.error,
                messageErrorFetch: action.payload.messageError
            }
        ////
        case actionTypes.GetSchemes:
            return {
                ...state,
                listSchemes: action.payload,
            }
        case actionTypes.getFunctionsSchema:
            return {
                ...state,
                listFunctionsSchema: action.payload,
            }
        case actionTypes.floChangeFlowInEdition:
            return {
                ...state,
                flowInEdition: action.payload,
            }
        case actionTypes.floIsChangesPendingFlow:
            return {
                ...state,
                isChangesPendingFlow: action.payload,
            }
        case actionTypes.getListTypesComponent:
            return {
                ...state,
                listTypesComponent: action.payload,
            }
        ////
        default:
            return state;
    }

}